/**
 * Social login account linking dialog Component
 */
/* jshint ignore:start */
(function (itxApp) {

    'use strict';

    /**
     * Social login account linking
     */
    var ItxSocialLoginLinkAccountDialogCmp = {
        bindings: {
            closeDialog: '&',
            onContinue: '&',
            user: '<'
        },
        controller: ItxSocialLoginLinkAccountDialogCmpCtrl,
        controllerAs: 'socialLoginLinkAccountDialogCtrl',
        templateUrl: ['$element', '$attrs', function ($element, $attrs) {
            return $attrs.template || 'social-login-link-account-dialog.tpl';
        }]
    };

    ItxSocialLoginLinkAccountDialogCmpCtrl.$inject = ['$rootScope', '$scope', 'ngDialog', 'ItxErrorMessagesFct'];

    function ItxSocialLoginLinkAccountDialogCmpCtrl($rootScope, $scope, ngDialog, ItxErrorMessagesFct) {
        var _this = this;
        _this.socialType = "";
        _this.userModel = {
            socialId: _this.user.socialId,
            socialToken: _this.user.socialToken,
            email: _this.user.email,
            privacyPolicyAccepted: true,
            socialType: _this.user.socialType
        };

        switch(_this.user.socialType){
            case "N":
                _this.socialType = "naver";
                break;
            case "F":
                _this.socialType = "facebook";
                break;
            case "G":
                _this.socialType = "google";
                break;
            case "I":
                _this.socialType = "instagram";
                break;
            case "W":
                _this.socialType = "wechat";
                break;
            case "A":
                _this.socialType = "appleid";
                break;
            default:
                console.log("Not defined type")
        }

        _this.showRecover = function () {
            ngDialog.open({
                template: 'user-access-dialog-wrapper.tpl',
                className: 'new-modal ma-modal-md ma-modal-macro recover-dialog ngdialog-theme-plain',
                showClose: true,
                bindToController: true,
                data: 'recover-password'
            });
        };

        _this.next = function () {
            _this.loginForm.$setSubmitted();

            if (_this.loginForm.$valid) {
                _this.onContinue({ user: _this.userModel });
            }
        };

    }

    /** Public */
    angular.module('itxApp.common')
        .component('itxSocialLoginLinkAccountDialog', ItxSocialLoginLinkAccountDialogCmp);

    itxApp.common.ItxSocialLoginLinkAccountDialogCmp = ItxSocialLoginLinkAccountDialogCmp;
    itxApp.common.ItxSocialLoginLinkAccountDialogCmpCtrl = ItxSocialLoginLinkAccountDialogCmpCtrl;

})(window.itxApp);
/* jshint ignore:end */